export default "__VITE_ASSET__6a519331__"